import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import styles from '../ForInvestors.module.scss';
import Buttonstyles from 'common/components/PrimaryButtonComponent/PrimaryButtonComponent.module.scss';
import {
  LOAD_STATES,
  FORM_SUCCESS_MESSAGE_TIMEOUT
} from 'common/consts/common';
import NewsletterService from 'services/Newsletter.service';
import Bind from 'lodash-decorators/bind';
import ContentStore from 'stores/Content.store';
import messages from '../ForInvestors.intl';

@injectIntl
@observer
export default class Newsletter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      checkbox: false,
      buttonState: '',
      showError: false
    };
  }

  resetState() {
    this.setState({
      email: '',
      checkbox: false,
      buttonState: '',
      showError: false
    });
  }

  @Bind
  createMarkup(val) {
    return { __html: val };
  }

  @Bind()
  updateInputValue(event) {
    const { id, type, checked, value: inputValue } = event.target;
    const value = type === 'checkbox' ? checked : inputValue;
    const currentState = this.state;
    currentState[id] = value;

    if (type === 'checkbox' && checked) {
      currentState.showError = false;
    } else if (type === 'checkbox' && !checked) {
      currentState.showError = true;
    }

    this.setState && this.setState(currentState);
  }

  @Bind()
  async submitForm(event) {
    event.preventDefault();
    const { email, checkbox } = this.state;

    if (checkbox) {
      this.setState({
        ...this.state,
        buttonState: LOAD_STATES.LOADING
      });
      try {
        await NewsletterService.sendNewsletter(email);
        this.setState({
          ...this.state,
          buttonState: LOAD_STATES.SUCCESS
        });

        setTimeout(() => {
          this.resetState();
        }, FORM_SUCCESS_MESSAGE_TIMEOUT);
      } catch (e) {
        this.setState({
          ...this.state,
          buttonState: LOAD_STATES.ERROR
        });
      }
    } else {
      this.setState({
        ...this.state,
        showError: true
      });
    }
  }

  render() {
    const { content } = ContentStore;

    const {
      ForInvestorsNewsletterTitle: newsletterTitle,
      ForInvestorsNewsletterSubtitle: newsletterSubtitle,
      ForInvestorsNewsletterAgreement: newsletterAgreement
    } = content;

    return (
      <form className={styles.Newsletter} onSubmit={this.submitForm}>
        <h2
          dangerouslySetInnerHTML={this.createMarkup(newsletterTitle)}
          htmlFor="email"
        />
        <h3 dangerouslySetInnerHTML={this.createMarkup(newsletterSubtitle)} />
        <input
          className={styles.NewsletterInput}
          id="email"
          placeholder={this.props.intl.formatMessage(messages.newsletterEmail)}
          type="text"
          onChange={this.updateInputValue}
          value={this.state.email ? this.state.email : ''}
        />
        <div className={styles.NewsletterCheckboxWrapper}>
          <input
            className={styles.input}
            type="checkbox"
            id="checkbox"
            onChange={this.updateInputValue}
          />
          <label className={styles.checkbox} htmlFor="checkbox">
            <div />
          </label>
          <label
            className={styles.label}
            htmlFor="checkbox"
            checkbox={this.state.checkbox}
            dangerouslySetInnerHTML={this.createMarkup(newsletterAgreement)}
          />
        </div>
        {this.state.showError ? (
          <p className={styles.errorMsg}>
            {this.props.intl.formatMessage(messages.newsletterWarning)}
          </p>
        ) : (
          <br />
        )}
        <div className={styles.ButtonWrapper}>
          <button
            type="submit"
            className={`
            ${Buttonstyles.PrimaryButtonComponent}
            ${styles.FillingButton}
          `}
          >
            {this.state.buttonState === LOAD_STATES.LOADING
              ? this.props.intl.formatMessage(messages.newsletterLoading)
              : this.state.buttonState === LOAD_STATES.SUCCESS
                ? this.props.intl.formatMessage(
                    messages.newsletterMessageSuccess
                  )
                : this.props.intl.formatMessage(messages.newsletterButton)}
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ForInvestors/components/Newsletter.js